<template>
  <div>
    <div class="center">
      <el-carousel class="car" height="390px" autoplay>
        <el-carousel-item v-for="(item, index) in sliders" :key="index">
          <img :src="item.img" class="slider_img" />
        </el-carousel-item>
      </el-carousel>
      <div class="about_main" v-if="lang == 'chs'">
        <!-- <h3 class="about_main_title">{{ mianText.title }}</h3> -->
        <div style="margin: 20px 0 17px;">{{ mianText.text1 }}</div>
        <div style="margin-bottom: 17px">{{ mianText.text2 }}</div>
        <!-- <div style="margin-bottom: 17px">{{ mianText.text3 }}</div> -->
      </div>
      <div class="about_main" v-else>
        <!-- <h3 class="about_main_title">{{ mianText.titleE }}</h3> -->
        <div style="margin: 20px 0 17px;">{{ mianText.text1E }}</div>
        <div style="margin-bottom: 17px">{{ mianText.text2E }}</div>
        <!-- <div style="margin-bottom: 17px">{{ mianText.text3E }}</div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomePage",
  data() {
    return {
      sliders: [],
      lang: "",
      mianText: {
        title: "关于",
        titleE: "About",
        text1:
          "水木资产管理有限公司持有香港证券及期货事务监察委员会根据香港《证券及期货条例》（香港法例第571章）颁发的第4类就证券提供意见和第9类提供资产管理牌照，中央编号为BTX926。我们只向专业投资者提供服务。",
        text1E:
          "Waterwood Asset Management Limited is licensed by Hong Kong's Securities and Futures Commission to conduct Type 4 (advising on securities) and Type 9 (asset management) regulated activities under the Securities and Futures Ordinance, Cap 571, Laws of Hong Kong. Our central entity number is BTX926. We provide services to professional investors only. ",
        text2:
          "我们专注于医疗、科技及新型经济产业扩展、整合和并购的投资机会。我们的投资团队成员包括来自跨国投资银行、私募和创投基金及法律会计专业领域的人士。他们积极与投资组合公司合作，提供商业网络、领域知识、企业管理经验和并购专业知识方面的关键资源。",
        text2E:
          "We invest primarily in growth stage, industry consolidation, and M&A opportunities in the healthcare, technology and new economy sectors. Our investment team comprises experienced executives and professionals from international investment banks, private equity and venture capital firms, and accounting and legal practices. They actively engage with our portfolio companies, providing critical resources in business networking, domain knowledge, corporate management experience, and M&A expertise.",
        // text3:
        //   "水木的投资者均为专业投资机构。为配合这些机构投资者的资产配置和回报要求，我们着重寻找被关注行业内的中外领先企业，判断该些企业在经济周期和行业整合中抵御风险和把握机会的能力，配合水木投资团队的人脉、行业、企业管理及并购的经验和资源，在适当时候向被选定的企业投放显著的资金，让企业能够利用资本杠杆和金融效率锐变，抛离竞争对手、整合产业格局或颠覆行业的既有持分者，成为行业的龙头或开创更有利自己发展的市场空间。",
        // text3E: "Waterwood provides services to professional investors only. To achieve the asset allocation and investment return expected by our investors, we focus on identifying Chinese and overseas leaders in its sectors of interest and assess their ability to tackle challenges and capture opportunities through economic cycles. We seek to deploy significant amount of capital at the right time to enable its portfolio companies to accelerate capital efficiency. In our active investment practice, we engage our portfolio companies in exploring our critical resources in business network, domain knowledge, corporate management experience, and M&A expertise. We encourage our partner entrepreneurs to fully leverage our commitments to outperform competitors, redefine industry landscape, and disrupt vested interests to become the winners and open up new business horizon. ",
      },
    };
  },
  methods: {},
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
    } else {
      this.lang = "chs";
    }
    this.sliders = [
      {
        img: require("../assets/images/ww.png"),
      },
      // {
      //   img: require("../assets/images/ww.png"),
      // },
    ];
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>
.center {
  width: 1200px;
  padding: 0 15px;
  margin: auto;
}
.car {
  width: 1200px;
  height: 390px;
  margin-top: 20px;
}
.slider_img {
  width: 1200px;
  height: 390px;
}
.about_main {
  margin-top: 30px;
  min-height: 260px;
  background: #fff;
  padding: 15px 50px;
  font-size: 16px;
  box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.about_main_title {
  padding: 15px 0;
}
</style>